import { ObservationDto } from '../../coaching-base/general';

import { ObservationFormValue } from './observation-form-value.model';

export function overrideObservation(
    original: ObservationDto,
    delta: ObservationDto,
): void {
    if (delta == null) {
        return;
    }

    original.event.duration = delta.event.duration;
    original.event.startTime = delta.event.startTime;

    original.focusContainers?.forEach((fc) => {
        const dfc = delta.focusContainers?.find((e) => {
            return (
                (e.behaviourId == null && fc.behaviourId == null) ||
                (e.behaviourId === fc.behaviourId &&
                    (e.subBehaviourId == null ||
                        e.subBehaviourId === fc.subBehaviourId))
            );
        });
        if (dfc == null) {
            return;
        }

        fc.interactions?.forEach((ict) => {
            const dict = dfc.interactions?.find((e) => {
                return (
                    (e.interactionId == null && ict.interactionId == null) ||
                    e.interactionId === ict.interactionId
                );
            });
            if (dict == null) {
                return;
            }

            ict.interactionDateTime = dict.interactionDateTime;
            ict.notes = dict.notes;
        });
    });
}

export function touchOverriddenObservation(
    original: ObservationFormValue,
    delta: ObservationDto,
): void {
    if (delta == null) {
        return;
    }

    original.tagGroups?.forEach((fc) => {
        const dfc = delta.focusContainers?.find((e) => {
            return (
                (e.behaviourId == null && fc.behaviourId == null) ||
                (e.behaviourId === fc.behaviourId &&
                    (e.subBehaviourId == null ||
                        e.subBehaviourId === fc.subBehaviourId))
            );
        });
        if (dfc == null) {
            return;
        }

        fc.trackingChanged = true;

        fc.interactions?.forEach((ict) => {
            const dict = dfc.interactions?.find((e) => {
                return (
                    (e.interactionId == null && ict.interactionId == null) ||
                    e.interactionId === ict.interactionId
                );
            });
            if (dict == null) {
                return;
            }

            ict.trackingTime = Date.now();
            ict.trackingChanged = true;

            ict.notes?.forEach((n) => {
                n.trackingTime = Date.now();
                n.changed = true;
            });
        });
    });
}
